import { Action, createReducer, on } from "@ngrx/store";

import { ConsumerDistributionKeysActions } from "../../actions/consumer-distribution-keys.actions";
import { ConsumerDistributionKeysState } from "../../models/mp-admin/consumer-distribution-keys-state";

const initialState: ConsumerDistributionKeysState = {
	keysByConsumerId: {},
	loading: false
};

const reducer = createReducer(
	initialState,

	on(ConsumerDistributionKeysActions.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerDistributionKeysActions.getSuccess, (state, { consumerId, keys }) => ({
		...state,
		keysByConsumerId: { ...state.keysByConsumerId, [consumerId]: keys },
		loading: false,
		error: undefined
	})),
	on(ConsumerDistributionKeysActions.getFail, (state, { error }) => ({
		...state,
		loading: false,
		error
	})),

	on(ConsumerDistributionKeysActions.createSuccess, (state, { consumerId, key }) => {
		const existing = state.keysByConsumerId[consumerId] ?? [];
		return {
			...state,
			keysByConsumerId: { ...state.keysByConsumerId, [consumerId]: [...existing, key] },
			loading: false,
			error: undefined
		};
	}),
	on(ConsumerDistributionKeysActions.createFail, (state, { error }) => ({
		...state,
		loading: false,
		error
	})),

	on(ConsumerDistributionKeysActions.updateSuccess, (state, { consumerId, key }) => {
		const existing = state.keysByConsumerId[consumerId];
		if (!existing) {
			return { ...state, error: undefined };
		}
		const idx = existing.findIndex((k) => k.id === key.id);
		if (idx === -1) {
			// Defensive no-op: the slice is the authoritative cache.
			// Appending would risk duplicates after the next list refetch.
			return { ...state, error: undefined };
		}
		const replaced = [...existing];
		replaced[idx] = key;
		return {
			...state,
			keysByConsumerId: { ...state.keysByConsumerId, [consumerId]: replaced },
			error: undefined
		};
	}),
	on(ConsumerDistributionKeysActions.updateFail, (state, { error }) => ({
		...state,
		error
	}))
);

export function consumerDistributionKeysReducer(
	state: ConsumerDistributionKeysState | undefined,
	action: Action
): ConsumerDistributionKeysState {
	return reducer(state, action);
}
